<template>
  <header class="App-header mdl-layout__header mdl-layout__header--scroll">
    <div class="App-layout__header-row mdl-layout__header-row">
      <span class="mdl-layout-title">
        <a class="App-logo">
          <div class="header-name">
            {{ meeting.name }} {{ previewModeText }}
          </div>
          <div class="header-title">
            <span class="text">{{ headerTitle }} {{ previewModeText }}</span>
          </div>
        </a>
      </span>
      <div class="mdl-layout-spacer"></div>
      <!-- Step counter -->
      <span class="mdl-layout-title">
        <span class="step-counter" v-if="!isDone">
          Step {{ steps.current }} of {{ totalSteps }}
        </span>
      </span>
    </div>
  </header>
</template>

<script>
// import api from '@/api.js';
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters({
      meeting: 'meeting/meeting',
      steps: 'steps',
      questions: 'questions/questions',
      trackingCode: 'trackingCode',
      token: 'token',
      previewMode: 'previewMode'
    }),
    isDone() {
      return this.path === '/done';
    },
    path() {
      return this.$route.path.split('?')[0];
    },
    totalSteps() {
      return this.steps.pathing.length - 1;
    },
    headerTitle() {
      if (this.steps.current === 0) {
        return this.meeting.name;
      } else if (
        this.steps.current > this.steps.stepMap[0].startIndex &&
        this.steps.current < this.steps.stepMap[2].startIndex
      ) {
        return 'Questions';
      } else {
        return 'Finish Up';
      }
    },
    previewModeText() {
      return this.previewMode ? '(Test mode)' : '';
    }
  },
  methods: {},
  mounted() {
    componentHandler.upgradeAllRegistered();
  }
};
</script>

<style scoped lang="scss">
.App-layout__header-row {
  padding-left: 40px;
}
.App-layout.is-small-screen .App-layout__header-row {
  padding-left: 16px;
}
.App-logo {
  color: #fff;
  text-decoration: none;
}

.header-title {
  display: flex;
  align-items: center;
}

.header-title > .header-icon {
  font-size: 25px;
  width: 40px;
}
.step-counter {
  font-size: 15px;
}

@media only screen and (max-width: 450px) {
  .mdl-layout__title,
  .mdl-layout-title {
    /* ellipsis overflow */
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    font-size: 16px;
  }
  .header-name {
    display: none;
  }
}

@media only screen and (min-width: 450px) {
  .header-title {
    display: none;
  }
  .step-counter {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue